<!-- Overlay de rate limiting -->
<app-rate-limit-overlay></app-rate-limit-overlay>

<!-- Contenido normal (se oculta cuando hay rate limiting) -->
<div *ngIf="!rateLimitActive" class="normal-content">
<div class="web">
  <div class="consultaContainer">
    <div class="consultaCenter">
      <div class="container-fluid mt-1" style="padding: 0;">
            <div class="row" style="margin: 0;padding: 0; padding-top: 1rem;">
              <div class="col-sm-12" style="margin: 0;padding: 0;">
                <div *ngIf="fResultados">
                  <p style="margin: 5px;padding: 0;">
                      <span class="tituloPanel">Fotografías</span>
                  </p>
                  <p style="margin: 0;padding: 0;">
                    <span class="titulo">{{tagChoosen}}</span>
                  </p>
                  <p style="margin: 5px 0; padding: 0;">
                    <span class="resultados-text">
                      {{ listProductos.response.nroTotalFilas }} {{ listProductos.response.nroTotalFilas === '1' ? 'resultado encontrado' : 'resultados encontrados' }}
                    </span>
                  </p>
                </div>
              </div>
            </div>

            <!-- Paginación superior -->
            <div class="col-sm-12 text-center" *ngIf="fResultados && totalPaginas > 1">
              <nav class="my-4">
                <ul class="pagination pagination-circle pg-red mb-0 justify-content-center">
                    <!--First-->
                    <li class="page-item" (click)="cambiarPagina(1)"><a class="page-link">Primero</a></li>
                    <!--Arrow left-->
                    <li class="page-item" (click)="cambiarPagina(paginaActual-1)">
                        <a class="page-link" aria-label="Previous">
                            <span aria-hidden="true">&laquo;</span>
                            <span class="sr-only">Anterior</span>
                        </a>
                    </li>
                    <li class="page-item {{active(a+1)}}" *ngFor="let a of filterRange(totalPaginasArray,rangoInicio,rangoFin); let i = index"><a (click)="cambiarPagina(a+1)" class="page-link ">{{a+1}}</a></li>
                    <li class="page-item" (click)="cambiarPagina(paginaActual+1)">
                        <a class="page-link" aria-label="Next">
                            <span aria-hidden="true">&raquo;</span>
                            <span class="sr-only">Siguiente</span>
                        </a>
                    </li>
                    <!--Last-->
                    <li class="page-item"  (click)="cambiarPagina(totalPaginas)"><a class="page-link">Último</a></li>
                </ul>
              </nav>
            </div>

            <div class="row" style="margin: 0; padding: 0;">
              <div class="col-sm-12">
                <div class="container-fluid">
                <div *ngIf="fResultados1" class="no-results-container">
                  <div class="no-results-card">
                    <div class="no-results-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                        <path d="M6.5 3a.5.5 0 0 1 .5.5V5h1.5a.5.5 0 0 1 0 1H7v1.5a.5.5 0 0 1-1 0V6H4.5a.5.5 0 0 1 0-1H6V3.5a.5.5 0 0 1 .5-.5z"/>
                      </svg>
                    </div>
                    <h3 class="no-results-title">No encontramos resultados</h3>
                    <p class="no-results-message">
                      No se encontraron publicaciones que coincidan con tu búsqueda.
                    </p>
                    <div *ngIf="lblFecIni && lblFecFin" class="no-results-filters">
                      <span class="filter-badge">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                          <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                        </svg>
                        {{lblFecIni}} - {{lblFecFin}}
                      </span>
                    </div>
                    <div class="no-results-suggestions">
                      <p class="suggestions-title">Sugerencias para mejorar tu búsqueda:</p>
                      <ul class="suggestions-list">
                        <li>Intenta con palabras más generales o diferentes</li>
                        <li>Verifica que las fechas sean correctas</li>
                        <li>Explora otras categorías o subcategorías</li>
                        <li>Revisa la ortografía de tus términos de búsqueda</li>
                      </ul>
                    </div>
                    <div class="no-results-actions">
                      <button class="btn-action btn-primary" (click)="limpiarFiltros()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z"/>
                          <path d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z"/>
                        </svg>
                        Limpiar filtros
                      </button>
                      <button class="btn-action btn-secondary" (click)="volverInicio()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                          <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5ZM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5 5 5Z"/>
                        </svg>
                        Volver al inicio
                      </button>
                    </div>
                  </div>
                </div>
                <div *ngIf="fResultados">
                  <div *ngIf="lblFecIni && lblFecFin && !lblTextoBusqueda">
                    <span style="margin-top: 10px;">Fecha Inicio: {{lblFecIni}} Fecha Fin: {{lblFecFin}}</span>
                    <br>
                  </div>
                  <div *ngIf="lblTextoBusqueda && !lblFecIni && !lblFecFin">
                    <span style="margin-top: 10px;">Búsqueda: {{lblTextoBusqueda}}</span>
                    <br>
                  </div>
                  <div *ngIf="lblFecIni && lblFecFin && lblTextoBusqueda">
                    <span style="margin-top: 10px;">Búsqueda: {{lblTextoBusqueda}} Fecha Inicio: {{lblFecIni}} Fecha Fin: {{lblFecFin}}</span>
                    <br>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="container-fluid">
                <!-- Dropdown de ordenamiento arriba a la derecha -->
                <!-- <div class="row" style="margin-bottom: 15px;" *ngIf="fResultados">
                  <div class="col-sm-8"></div>
                  <div class="col-sm-4 text-right">
                    <select class="form-control form-control-sm d-inline-block" style="width: auto; display: inline-block;" (change)="onSortChange($event.target.value)" [value]="currentSortValue">
                      <option value="">Ordenar por</option>
                      <option value="alfabetico_asc">Alfabético A-Z</option>
                      <option value="alfabetico_desc">Alfabético Z-A</option>
                      <option value="fecha_asc">Fecha Ascendente</option>
                      <option value="fecha_desc">Fecha Descendente</option>
                    </select>
                  </div>
                </div> -->
                <div class="row" *ngIf="!fMerchadising && !isLoading">
                          <div class="contenedor-galeria">
                            <div class="columna-galeria" *ngFor="let columna of columnas">

                              <div class="item-galeria" *ngFor="let item of columna">

                                <div class="panelLibWeb" *ngIf="fResultados" [routerLink]="['/dt', item.titleShowUrl, item.id]" style="cursor: pointer;" (mousemove)="onMouseMove($event)" (mouseleave)="onMouseLeave($event)">
                                  <div class="container-fluid" style="padding: 0;">
                                    <div class="row">
                                      <div class="col-sm-6" style="padding: 0 15px;">
                                        <!-- Skeleton SIN marco -->
                                        <div *ngIf="shouldShowSkeleton(item.activoId)"
                                             class="skeleton-container"
                                             style="width: 100%; margin-top: 5px;"
                                             [style.aspect-ratio]="getSkeletonAspectRatio(item)">
                                          <app-image-skeleton
                                            [width]="'100%'"
                                            [height]="'100%'"
                                            size="large"
                                            [class]="getSkeletonOrientationClass(item)">
                                          </app-image-skeleton>
                                        </div>

                                        <!-- Imagen CON marco (solo cuando está cargada) -->
                                        <a *ngIf="!shouldShowSkeleton(item.activoId)" class="btnDetalleFoto imagen-3d">
                                          <ng-container *ngIf="getProtectedImageUrl(item.activoId)">
                                            <img class="img-fluid"
                                                 [src]="getProtectedImageUrl(item.activoId)"
                                                 alt="{{item.title}} - Imagen Protegida">
                                          </ng-container>
                                        </a>

                                        <!-- Ver detalle completo debajo de la imagen -->
                                        <div class="ver-mas-indicator">
                                          <span>Ver detalle completo</span>
                                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M5.5 7a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L11.293 7H5.5z"/>
                                          </svg>
                                        </div>
                                      </div>
                                      <div class="col-sm-6" style="padding: 0; padding-right: 5px; text-align: left; position: relative;">
                                        <p class="tituloFoto" >{{item.title}}</p>
                                        <p class="descripcionFoto">{{item.subtitle}}</p>
                                        <p></p>
                                        <!-- <p class="precioFoto">S/ {{item.price}}</p> -->
                                        <p class="descripcionFoto">{{item.description}}</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                              </div>

                            </div>
                          </div>
                    </div>
                    <div class="row" *ngIf="!fMerchadising && !isLoading">
                      <div class="col-sm-4"></div>
                      <div class="col-sm-4 text-center">
                        <nav class="my-4" *ngIf="fResultados">
                          <ul class="pagination pagination-circle pg-red mb-0">
                            <li class="page-item" (click)="cambiarPagina(1)"><a class="page-link">Primero</a></li>
                            <li class="page-item" (click)="cambiarPagina(paginaActual-1)">
                              <a class="page-link" aria-label="Previous">
                                <span aria-hidden="true">&laquo;</span>
                                <span class="sr-only">Anterior</span>
                              </a>
                            </li>
                            <li class="page-item {{active(a+1)}}" *ngFor="let a of filterRange(totalPaginasArray,rangoInicio,rangoFin); let i = index">
                              <a (click)="cambiarPagina(a+1)" class="page-link">{{a+1}}</a>
                            </li>
                            <li class="page-item" (click)="cambiarPagina(paginaActual+1)">
                              <a class="page-link" aria-label="Next">
                                <span aria-hidden="true">&raquo;</span>
                                <span class="sr-only">Siguiente</span>
                              </a>
                            </li>
                            <li class="page-item" (click)="cambiarPagina(totalPaginas)">
                              <a class="page-link">Último</a>
                            </li>
                          </ul>
                        </nav>
                      </div>
                      <div class="col-sm-4"></div>
                    </div>
                </div>
              </div>
            </div>
      </div>
    </div>
  </div>
</div>

<div class="movil">
  <div class="consultaContainerM">
    <div class="consultaCenterM">
  
        <div class="container-fluid mt-1" style="padding:0;">
                <div class="row" style="margin: 0;padding: 0; padding-top: 0.5rem;">
                  <div class="col-sm-12" style="margin: 0;padding: 0;">
                    <p style="margin: 0;padding: 0;">
                        <span class="tituloPanel">Fotografías</span>
                    </p>
                    <p style="margin: 0;padding: 0;">
                      <span class="titulo">{{tagChoosen}}</span>
                    </p>
                  </div>
                </div>
                <div class="row" style="margin: 0;padding: 0; padding-top: 0.25rem;">
                    <div class="col-sm-12 text-center">
                      <div class="container">
                        <div class="row">
                          <div class="col-sm-12 mb-2" *ngIf="fSubCategoria">
                            <select class="dropdown-toggle orden waves-light btnSubtipo" (change)="cambiarSubCategoria($event.target.value)" [(ngModel)]="LSubCategoria" name="select">
                              <option *ngFor="let item of listSubCategoria.response.list" value="{{item.id}}">{{item.descript.charAt(0).toUpperCase() + item.descript.slice(1).toLowerCase()}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-12">
                      <div class="container-fluid">
                        <!-- Header de resultados con contador -->
                        <div class="resultados-header" *ngIf="fResultados">
                          <span class="resultados-text">
                            Resultados: {{ listProductos.response.nroTotalFilas }} {{ listProductos.response.nroTotalFilas === '1' ? 'encontrado' : 'encontrados' }}
                          </span>
                        </div>

                        <!-- Paginación superior -->
                        <div class="col-sm-12 text-center" *ngIf="fResultados && totalPaginas > 1">
                          <nav class="my-4">
                            <ul class="pagination pagination-circle pg-red mb-0 justify-content-center">
                                <!--First-->
                                <li class="page-item" (click)="cambiarPagina(1)"><a class="page-link">&#171;&#171;</a></li>
                                <!--Arrow left-->
                                <li class="page-item" (click)="cambiarPagina(paginaActual-1)">
                                    <a class="page-link" aria-label="Previous">
                                        <span aria-hidden="true">&laquo;</span>
                                        <span class="sr-only">Anterior</span>
                                    </a>
                                </li>
                                <li class="page-item {{active(a+1)}}" *ngFor="let a of filterRange(totalPaginasArray,rangoInicio,rangoFin); let i = index"><a (click)="cambiarPagina(a+1)" class="page-link ">{{a+1}}</a></li>
                                <li class="page-item" (click)="cambiarPagina(paginaActual+1)">
                                    <a class="page-link" aria-label="Next">
                                        <span aria-hidden="true">&raquo;</span>
                                        <span class="sr-only">Siguiente</span>
                                    </a>
                                </li>
                                <!--Last-->
                                <li class="page-item"  (click)="cambiarPagina(totalPaginas)"><a class="page-link">&#187;&#187;</a></li>
                            </ul>
                          </nav>
                        </div>

                        <div *ngIf="fResultados1" class="no-results-container">
                          <div class="no-results-card">
                            <div class="no-results-icon">
                              <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                                <path d="M6.5 3a.5.5 0 0 1 .5.5V5h1.5a.5.5 0 0 1 0 1H7v1.5a.5.5 0 0 1-1 0V6H4.5a.5.5 0 0 1 0-1H6V3.5a.5.5 0 0 1 .5-.5z"/>
                              </svg>
                            </div>
                            <h3 class="no-results-title">No encontramos resultados</h3>
                            <p class="no-results-message">
                              No se encontraron publicaciones que coincidan con tu búsqueda.
                            </p>
                            <div *ngIf="lblFecIni && lblFecFin" class="no-results-filters">
                              <span class="filter-badge">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                                  <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                                </svg>
                                {{lblFecIni}} - {{lblFecFin}}
                              </span>
                            </div>
                            <div class="no-results-suggestions">
                              <p class="suggestions-title">Sugerencias para mejorar tu búsqueda:</p>
                              <ul class="suggestions-list">
                                <li>Intenta con palabras más generales o diferentes</li>
                                <li>Verifica que las fechas sean correctas</li>
                                <li>Explora otras categorías o subcategorías</li>
                                <li>Revisa la ortografía de tus términos de búsqueda</li>
                              </ul>
                            </div>
                            <div class="no-results-actions">
                              <button class="btn-action btn-primary" (click)="limpiarFiltros()">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                  <path fill-rule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z"/>
                                  <path d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z"/>
                                </svg>
                                Limpiar filtros
                              </button>
                              <button class="btn-action btn-secondary" (click)="volverInicio()">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                  <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5ZM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5 5 5Z"/>
                                </svg>
                                Volver al inicio
                              </button>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="fResultados">
                          <div *ngIf="lblFecIni && lblFecFin && !lblTextoBusqueda">
                            <span style="margin-top: 10px;">Fecha Inicio: {{lblFecIni}} Fecha Fin: {{lblFecFin}}</span>
                            <br>
                          </div>
                          <div *ngIf="lblTextoBusqueda && !lblFecIni && !lblFecFin">
                            <span style="margin-top: 10px;">Búsqueda: {{lblTextoBusqueda}}</span>
                            <br>
                          </div>
                          <div *ngIf="lblFecIni && lblFecFin && lblTextoBusqueda">
                            <span style="margin-top: 10px;">Búsqueda: {{lblTextoBusqueda}} Fecha Inicio: {{lblFecIni}} Fecha Fin: {{lblFecFin}}</span>
                            <br>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-12 mt-1" style="padding: 0;">
                      <div class="container-fluid">
                        <div class="row" *ngIf="!fMerchadising && !isLoading">
                            <div class="col-12 col-md-6 col-lg-4" *ngFor="let item of listProductos.response.list" style="padding: 0;">
                                <div class="panelLibMovil" *ngIf="fResultados" style="cursor: pointer;" [routerLink]="['/dt/'].concat(item.titleShowUrl).concat(item.id)">
                                  <div class="container-fluid">
                                    <div class="row">
                                      <div class="col-6">
                                        <!-- Skeleton SIN marco -->
                                        <div *ngIf="shouldShowSkeleton(item.activoId)"
                                             class="skeleton-container"
                                             style="width: 100%; margin-top: 5px;"
                                             [style.aspect-ratio]="getSkeletonAspectRatio(item)">
                                          <app-image-skeleton
                                            [width]="'100%'"
                                            [height]="'100%'"
                                            size="large"
                                            [class]="getSkeletonOrientationClass(item)">
                                          </app-image-skeleton>
                                        </div>

                                        <!-- Imagen CON marco holográfico (solo cuando está cargada) -->
                                        <a *ngIf="!shouldShowSkeleton(item.activoId)" class="btnDetalleFoto" >
                                          <div class="marco-container-mobile">
                                            <div class="imagen-container-holografico-mobile">
                                              <ng-container *ngIf="getProtectedImageUrl(item.activoId)">
                                                <img [src]="getProtectedImageUrl(item.activoId)"
                                                     width="100%"
                                                     alt="{{item.title}} - Imagen Protegida">
                                              </ng-container>
                                            </div>
                                          </div>
                                        </a>
                                      </div>
                                      <div class="col-6" style="text-align: left;">
                                        <p class="tituloFoto">{{item.title}}</p>
                                        <p class="descripcionFoto">{{item.subtitle}}</p>
                                        <p></p>
                                        <!-- <p class="precioFoto">S/ {{item.price}}</p> -->
                                        <p class="descripcionFoto">{{item.description}}</p>
                                     
                                      </div>
                                    </div>
                                  </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" *ngIf="!fMerchadising && !isLoading">
                          <div class="col-sm-4"></div>
                          <div class="col-sm-4 text-center">
                            <nav class="my-4" *ngIf="fResultados">
                              <ul class="pagination pagination-circle pg-red mb-0">
                                <li class="page-item" (click)="cambiarPagina(1)"><a class="page-link">&#171;&#171;</a></li>
                                <li class="page-item" (click)="cambiarPagina(paginaActual-1)">
                                  <a class="page-link" aria-label="Previous">
                                    <span aria-hidden="true">&laquo;</span>
                                    <span class="sr-only">Anterior</span>
                                  </a>
                                </li>
                                <li class="page-item {{active(a+1)}}" *ngFor="let a of filterRange(totalPaginasArray,rangoInicio,rangoFin); let i = index">
                                  <a (click)="cambiarPagina(a+1)" class="page-link">{{a+1}}</a>
                                </li>
                                <li class="page-item" (click)="cambiarPagina(paginaActual+1)">
                                  <a class="page-link" aria-label="Next">
                                    <span aria-hidden="true">&raquo;</span>
                                    <span class="sr-only">Siguiente</span>
                                  </a>
                                </li>
                                <li class="page-item" (click)="cambiarPagina(totalPaginas)">
                                  <a class="page-link">&#187;&#187;</a>
                                </li>
                              </ul>
                            </nav>
                          </div>
                          <div class="col-sm-4"></div>
                        </div>
                    </div>
                </div>
          </div>
      </div>
    </div>
  </div>
</div>
<!-- Fin del contenido normal -->